module.exports = __webpack_public_path__ + "static/media/AlertBlue.c196bffd.svg";